import { type Shipment } from 'shipments/domain/Shipment'

import { type Stop } from '../../domain/Stop'
import { type Participant } from '../domain/Chat'

export function formatChatSubject(carrierName: string | undefined, stops: Stop[]) {
  if (!stops.length || !carrierName) {
    return ''
  }

  const firstStop = stops.at(0)!
  const lastStop = stops.at(-1)!

  return `${carrierName} • ${firstStop.city} to ${lastStop.city} • Working group`
}

/**
 * While the chat is loading, we don't have the participants yet, so we use the shipment data to create the subtitle.
 */
export function formatChatSubtitle(shipment: Shipment, participants?: Pick<Participant, 'name'>[]) {
  if (participants && participants.length > 0) {
    return participants.map(({ name }) => name).join(', ')
  }

  return `${shipment.carrier.name}, ${shipment.shipper!.companyName}`
}
